import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import messages from './messages'
import QuestionTitle from '@/programmes/components/FormV2/components/QuestionTitle/QuestionTitle'
import QuestionBody from '@/programmes/components/FormV2/components/QuestionBody'
import { useTrackingQuestionnaire } from '@/programmes/tracking'

const BodyMessage = () => {
  const formatMessage = useFormatMessage()

  return (
    <p>
      {formatMessage(messages.needAssistance)}{' '}
      <a
        href="https://support.babylonhealth.com/cspbabylonsupport?id=csp_sc_cat_item&table=sc_cat_item&sys_id=09cd304c8736e1101b157488dabb354d"
        target="_blank"
        rel="noreferrer"
      >
        {formatMessage(messages.body)}
      </a>
    </p>
  )
}

const ExitView = () => {
  const formatMessage = useFormatMessage()
  useTrackingQuestionnaire('exit')

  return (
    <div>
      <QuestionTitle content={formatMessage(messages.title)} type="header" />

      <QuestionBody body={<BodyMessage />} />
    </div>
  )
}

export default ExitView
